import './styles/App.css';
import './styles/style.css';
import './styles/html-css/bootstrap.css';
import './styles/html-css/swiper.css';
import './styles/html-css/dark.css';
import './styles/html-css/font-icons.css';
import './styles/html-css/animate.css';
import './styles/html-css/magnific-popup.css';
import './styles/html-css/custom.css';
import Minter from './pages/Minter';

function App() {
  return (
    <div className='App'>
      <Minter />
    </div>
  );
}

export default App;
